import React, { useEffect, useState } from "react";
import Review from "./Review";
import PaymentDetail from "./PaymentDetail";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import HotelGuestForm from "./HotelGuestForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getLoading,
  getsingleHotelPrice,
  fetchSingleHotelDataPrice,
  resetCounts,
  selectHotelRoomAsync,
} from "../../../../features/bookings/hotelSlice";
import { isObject } from "lodash";
import Loader from "../../../../helpers/Loader";
import { useRef } from "react";

const HotelReview = () => {
  const [val, setVal] = useState([]);
  const [form, setForm] = useState([]);
  const [match, setMatch] = useState([]);
  const [totals, setTotals] = useState([]);
  const navigate = useNavigate();
  const scrollIntoView = useRef(null);
  const selectRooms = useSelector(
    (state) => state.hotel.SelectRoom,
    shallowEqual
  );
  const [searchParams] = useSearchParams();
  const singleHotelPrice = useSelector(getsingleHotelPrice);
  const dispatch = useDispatch();
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams])
  );

  useEffect(() => {
    let queryData = Object.fromEntries([...searchParams]);
    const sessionData = JSON.parse(sessionStorage.getItem("hotelForm"));
    const guestDetails = JSON.parse(sessionData.guestDetails);
    dispatch(
      selectHotelRoomAsync({ code: queryData.BookingCode, Authorization })
    );
  }, []);

  useEffect(() => {
    let val = JSON.parse(sessionStorage.getItem("hotelDetails"));
    if (val !== null) {
      setVal(val);
      setForm(JSON.parse(sessionStorage.getItem("hotelForm")));
      scrollIntoView.current?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
    }
  }, []);

  React.useEffect(() => {
    if (Object.keys(queryData).length > 0) {
      let val = JSON.parse(queryData.guestDetails);

      let check = val.reduce(
        (sum, cur) => {
          return {
            rooms: val.length,
            Adults: sum.Adults + cur.Adults,
            Children: sum.Children + cur.Children,
            Total: sum.Adults + cur.Adults + sum.Children + cur.Children,
          };
        },
        {
          Adults: 0,
          Children: 0,
          Total: 0,
        }
      );
      setTotals(check);
    }
  }, [queryData]);

  useEffect(() => {
    // console.log({ selectRooms });
    if (selectRooms?.data?.length > 0) {
      let ans = selectRooms?.data?.[0].Rooms.find((ele) => {
        return ele.BookingCode == queryData.BookingCode;
      });
      setMatch(ans);
    }
  }, [selectRooms]);

  // if(loading){
  //   return <Loader />
  // }

  return (
    <>
      <section className="review-booking hotel-review" ref={scrollIntoView}>
        <div className="container">
          <div className="row">
            <div>
              <h3 className="title">Review your Booking</h3>
            </div>
            <div className="col-lg-8">
              <Review
                detail={val}
                formData={form}
                match={match}
                totals={totals}
              />

              {val.length !== 0 && (
                <HotelGuestForm
                  code={queryData.BookingCode}
                  val={val}
                  match={match}
                  total={match?.TotalFare}
                  guests={{ adults: form.adults, childs: form.childs }}
                  checkIn={form.checkIn}
                  checkOut={form.checkOut}
                />
              )}
            </div>
            <div className="col-lg-4">
              <PaymentDetail formData={form} val={val} match={match} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HotelReview;
